import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { individusService } from "../../services";
import { CustomDialog, showToast } from "..";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../utils/UserProvider";

interface ModalAddIndividuProps {
  closeModalIndividu: () => void;
  modalIsOpenIndividu: boolean;
  openModalActif: () => void;
}
const ModalAddIndividu = ({
  closeModalIndividu,
  modalIsOpenIndividu,
  openModalActif,
}: ModalAddIndividuProps) => {
  const queryClient = useQueryClient();
  const { client } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data: any) => {
    try {
      const IndividuData = {
        nom_individu: data.nom_individu,
        prenom_individu: data.prenom_individu,
        env_client_id: client.id,
        numéro_fiscal:data.numéro_fiscal,
        numéro_propriétaire:data.numéro_propriétaire

      };
      setLoading(true);
      await individusService.post(IndividuData).then((response) => {
        setLoading(false);
        showToast("success", "Individu ajouté avec succès");
        queryClient.refetchQueries({
          queryKey: ["individus"],
        });
        reset();
        closeModalIndividu();
        openModalActif();
      });
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  return (
    <CustomDialog
      header="Ajouter une nouvelle individu physique"
      visible={modalIsOpenIndividu}
      closeModalDialog={() => {
        closeModalIndividu();
        reset();
      }}
      customStyle={{ width: "40vw" }}
    >
      <div className="w-full h-full">
        <div className="p-6 space-y-6">
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            <div className="grid grid-cols-6 gap-6 ">
              <div className="col-span-6 sm:col-span-6">
                <label
                  htmlFor="nom_societe"
                  className="block text-md font-bold leading-6 text-gray-900"
                >
                  Nom individu *
                </label>
                <input
                  type="text"
                  name="nom_individu"
                  id="nom_individu"
                  placeholder="Saisir nom"
                  className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                  {...register("nom_individu", {
                    required: true,
                  })}
                />
                {errors.nom_individu && (
                  <span className="bg-red-100 text-red-800 text-sm font-medium mr-2 my-4  px-2 py-1 rounded ">
                    champs obligatoire
                  </span>
                )}
              </div>
              <div className="col-span-6 sm:col-span-6">
                <label
                  htmlFor="prenom_individu"
                  className="block text-md font-bold leading-6 text-gray-900"
                >
                  Prénom individu *
                </label>
                <input
                  type="text"
                  name="prenom_individu"
                  id="prenom_individu"
                  placeholder="Saisir prénom"
                  className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                  {...register("prenom_individu", {
                    required: true,
                  })}
                />
                {errors.prenom_individu && (
                  <span className="bg-red-100 text-red-800 text-sm font-medium mr-2 my-4  px-2 py-1 rounded ">
                    champs obligatoire
                  </span>
                )}
              </div>






              <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="numéro_fiscal"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Numéro fiscal *
              </label>
              
              <input
                type="text"
                name="numéro fiscal"
                id="numéro_fiscal"
                placeholder="Saisir numéro fiscal"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("numéro_fiscal", {
                  required: true,
                  pattern: {
                    value: /^[A-Za-z0-9]+$/,
                    message: "Format invalide "
                }
                })
              }
               
              />
              {errors.numéro_fiscal && (
                <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                  {errors.numéro_fiscal?.message as string}
                </span>
              )}
            </div>



            <div className="col-span-3 sm:col-span-3">
              <label
                htmlFor="numéro_propriétaire"
                className="block text-md font-bold leading-6 text-gray-900"
              >
                Numéro de propriétaire *
              </label>
              
              <input
                type="text"
                name="numéro de propriétaire"
                id="numéro_propriétaire"
                placeholder="Saisir numéro de propriétaire"
                className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                {...register("numéro_propriétaire", {
                  required: true,
                  pattern: {
                    value: /^[A-Za-z0-9]+$/,
                    message: "Format invalide"
                }
                })
              }
               
              />
              {errors.numéro_propriétaire && (
                <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                  {errors.numéro_propriétaire?.message as string}
                </span>
              )}
            </div>







            </div>
            <p className=" text-lg font-thin my-4">* obligatoire</p>

            <div className="flex justify-end space-x-2 mt-10">
              <button
                type="submit"
                className="text-white bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
              >
                {loading && (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 mr-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                )}
                Ajouter
              </button>
              <button
                type="button"
                onClick={() => {
                  reset();
                  closeModalIndividu();
                  openModalActif();
                }}
                className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-2  text-center "
              >
                Retour
              </button>
            </div>
          </form>
        </div>
      </div>
    </CustomDialog>
  );
};

export default ModalAddIndividu;
